<div class="red-circle btn_red" (click)="onPress()">
    <mat-icon class="white-icon" aria-hidden="false" aria-label="X Icon">close</mat-icon>
</div>
